import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-main">
        <div className="container footer-grid">
          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">About Us</Link></li>
              <li><Link to="/">Accessibility</Link></li>
              <li><Link to="/">Careers</Link></li>
              <li><Link to="/">Budget &amp; Performance</Link></li>
              <li><Link to="/">Agency Components</Link></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Information</h4>
            <ul>
              <li><Link to="/">Freedom of Information</Link></li>
              <li><Link to="/">No FEAR Act Data</Link></li>
              <li><Link to="/">Inspector General</Link></li>
              <li><Link to="/">White House Links</Link></li>
              <li><Link to="/">USA.gov</Link></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Policies</h4>
            <ul>
              <li><Link to="/">Privacy &amp; Legal</Link></li>
              <li><Link to="/">Disclaimers</Link></li>
              <li><Link to="/">Site Map</Link></li>
              <li><Link to="/">Report Vulnerability</Link></li>
              <li><Link to="/">Contact Us</Link></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Connect With Us</h4>
            <p className="footer-social-desc">Follow us on social media for updates and announcements.</p>
            <div className="social-links">
              {['facebook','twitter','youtube','instagram','linkedin','email'].map((s) => (
                <a href="#" key={s} className="social-icon" aria-label={s} title={s}>
                  {s === 'facebook' && <svg viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg>}
                  {s === 'twitter' && <svg viewBox="0 0 24 24" fill="currentColor"><path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"/></svg>}
                  {s === 'youtube' && <svg viewBox="0 0 24 24" fill="currentColor"><path d="M22.54 6.42a2.78 2.78 0 00-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 00-1.95 1.96A29 29 0 001 12a29 29 0 00.46 5.58A2.78 2.78 0 003.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 001.95-1.95A29 29 0 0023 12a29 29 0 00-.46-5.58z"/><polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="white"/></svg>}
                  {s === 'instagram' && <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/></svg>}
                  {s === 'linkedin' && <svg viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2"/></svg>}
                  {s === 'email' && <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>}
                </a>
              ))}
            </div>
            <div className="system-status">
              <span className="status-dot" />
              All systems operational
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <div className="footer-agency">
            <div className="agency-seal">USCIS</div>
            <div>
              <strong>Federal Services Portal</strong>
              <p>An official public service website</p>
            </div>
          </div>
          <div className="footer-bottom-links">
            {['About FSP','Components','Office of Inspector General','Privacy and Legal',
              'Accessibility','Freedom of Information Act','White House','Site Map',
              'Budget & Performance','No FEAR Act Data','USA.gov'].map((l) => (
              <Link to="/" key={l}>{l}</Link>
            ))}
          </div>
          <div className="footer-status-box">
            <strong>System Status:</strong>
            <p>All systems operational. Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
